// ... existing code ...
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";

const Edit = (props) => {
  const navigate = useNavigate();
const { id } = useParams();
const [inputs, setInputs] = useState({ mushok_6_4_show: true });
const [unit, setUnit] = useState({});
const [factories, setFactories] = useState([]); // For storing factory data
const [selectedFactoryOption, setSelectedFactoryOption] = useState(null);
const [unitSupply, setUnitSupply] = useState([]);
const [category, setCategory] = useState({});
const [error, setError] = useState({});
const [showAccountsForm, setShowAccountsForm] = useState(false);
const [finishedGoodsDepartments, setfinishedGoodsDepartments] = useState([]);
const [selectedUnitOption, setSelectedUnitOption] = useState(null);
const [selectedDepartmentArt, setSelectedDepartmentArt] = useState(null);
const [selectedUnitSupplyOption, setSelectedUnitSupplyOption] =
  useState(null);
const [selectProductCatOption, setSelectProductCatOption] = useState(null);
const [loading, setLoading] = useState(false);
const [departments, setDepartments] = useState([]); // For storing factory data
// New states for shapes
const [shapes, setShapes] = useState([]);
const [selectedShapes, setSelectedShapes] = useState([]);
const [shapesLoading, setShapesLoading] = useState(false);
const [shapesError, setShapesError] = useState(null);

const fetchData = async () => {
  setLoading(true);
  try {
    const productRes = await Http.get("/product/" + id);
    console.log(productRes.data);
    // Map existing shapes to react-select format
    const initialSelectedShapes = (productRes.data.shapes || []).map(
      (s) => ({
        value: s.id,
        label: s.name,
      })
    );
    setSelectedShapes(initialSelectedShapes);
    
    setInputs({
      code: productRes.data.code,
      name: productRes.data.name,
      unit_id: productRes.data.unit_id,
      price: productRes.data.price,
      sku: productRes.data.sku,
      pack_size: productRes.data.pack_size,
      stock: productRes.data.stock,
      type: productRes.data.type,
      category_id: productRes.data.category_id,
      notes: productRes.data.notes,
      vat: productRes.data.vat,
      status: productRes.data.status,
      std_price_accounts: productRes.data.std_price_accounts,
      vat_value_accounts: productRes.data.vat_value_accounts,
      sdv_inv: productRes.data.sdv_inv,
      sd_inv: productRes.data.sd_inv,
      vat_inv: productRes.data.vat_inv,
      unit_supply: productRes.data.unit_supply,
      unit_supply_qty: productRes.data.unit_supply_qty,
      mushok_6_4_show: productRes.data.mushok_6_4_show,
      department_finished_good: productRes.data.department_finished_good, // Ensure this field is set if it exists
      has_handle: productRes.data.has_handle, // Ensure this field is set if it exists
      // Add slice_weight, green_weight, etc. if they are part of product data
      slice_weight: productRes.data.slice_weight,
      green_weight: productRes.data.green_weight,
      glost_weight: productRes.data.glost_weight,
      biscuit_weight: productRes.data.biscuit_weight,
      fg_weight: productRes.data.fg_weight,
      department_art_id: productRes.data.department_art_id,
    });
    setSelectedUnitOption({
      label: productRes.data.unit.name,
      value: productRes.data.unit.id,
    });
    setSelectedDepartmentArt({
      label: productRes.data.department_art.name,
      value: productRes.data.department_art.id,
    });
    // setSelectProductCatOption({
    //   label: productRes.data.category.name,
    //   value: productRes.data.category.id,
    // });
    const unitRes = await Http.get("/unitSelect2");
    setUnit(unitRes.data);
    // const factoryRes = await Http.get("/factory");
    // setFactories(factoryRes.data);
   const departmentRes = await Http.get("/departmentArtSelect2");
   setDepartments(departmentRes.data);
   const selectedDepartments = departmentRes.data.filter(
    (dept) => dept.value === 2 || dept.value === 3
  );
  setfinishedGoodsDepartments(selectedDepartments);
   // Set default factory option
  //  const selectedFactory = factoryRes.data.find(
  //    (factory) => factory.id === productRes.data.id
  //  );
  //  if (selectedFactory) {
  //    setSelectedFactoryOption({
  //      label: selectedFactory.name,
  //      value: selectedFactory.id,
  //    });
  //  }
  //  const categoryRes = await Http.get("/productCatSelect2");
  //  setCategory(categoryRes.data);
  //  const unitSupplyRes = await Http.get("/unitSelect2");
  //  setUnitSupply(unitSupplyRes.data);
 } catch (error) {
   console.error("Fetch error:", error);
 } finally {
   setLoading(false);
 }
};

useEffect(() => {
 fetchData();
}, []);
// Effect to fetch shapes when product type is finished_goods
useEffect(() => {
 if (inputs.type === "finished_goods") {
   setShapesLoading(true);
   setShapesError(null);
   Http.get("/shape")
     .then((res) => {
       const options = (res.data || []).map((s) => ({
         value: s.id ?? s.value ?? s.shape_id ?? s,
         label: s.name ?? s.label ?? s.shape_name ?? String(s),
       }));
       setShapes(options);
     })
     .catch((err) => {
       setShapesError("Could not fetch shapes.");
     })
     .finally(() => setShapesLoading(false));
 } else {
   // Clear shapes if type is not finished_goods
   setShapes([]);
   setSelectedShapes([]);
 }
}, [inputs.type]);

useEffect(() => {
 if (inputs.type === "finished_goods") {
   setShowAccountsForm(true);
 } else {
   setShowAccountsForm(false);
 }
}, [inputs.type]);

const selectHandleChange = (selectedOption, actionMeta) => {
 if (actionMeta.name === "unit_id") {
   setSelectedUnitOption({
     label: selectedOption.label,
     value: selectedOption.value,
   });
 }
 if (actionMeta.name === "department_art_id") {
  setSelectedDepartmentArt({
     label: selectedOption.label,
     value: selectedOption.value,
   });
 }
 if (actionMeta.name === "category_id") {
   setSelectProductCatOption({
     label: selectedOption.label,
     value: selectedOption.value,
   });
 }
 if (actionMeta.name === "factory_id") {
   setSelectedFactoryOption({
     label: selectedOption.label,
     value: selectedOption.value,
   });
 }
 if (actionMeta.name === "unit_supply") {
   setSelectedUnitSupplyOption({
     label: selectedOption.label,
     value: selectedOption.value,
   });
 }
 const name = actionMeta.name;
 const value = selectedOption.value;
 setInputs((values) => ({ ...values, [name]: value }));
};
// Handle change for multi-select (React-Select sends selected options directly)
const handleMultiSelectChange = (selectedOptions, actionMeta) => {
 if (actionMeta.name === "supported_shapes") {
   setSelectedShapes(selectedOptions);
  }
};

const handleChange = (e) => {
  const name = e.target.name;
  const value =
    e.target.type === "checkbox" ? e.target.checked : e.target.value;
  setInputs((values) => ({ ...values, [name]: value }));
};

const formSubmit = () => {
  console.log(inputs);
  let submitPayload = { ...inputs };

  if (inputs.type === "finished_goods") {
    submitPayload.supported_shapes = selectedShapes.map((s) => s.value);
  } else {
    // If not finished_goods, ensure supported_shapes is not sent or is empty
    submitPayload.supported_shapes = [];
  }

  Http.put("/product/" + id, submitPayload) // Send the modified payload
    .then((res) => {
      navigate("/product", {
        state: { message: res.data.message, type: res.data.type },
      });
    })
    .catch(function (e) {
      setError(e.response.data.errors);
    });
};


  return (
    <div>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Product Form</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Edit Product Form</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Code <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="code"
                      value={inputs.code || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>
                      Name <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Unit <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={selectedUnitOption}
                      value={selectedUnitOption}
                      onChange={selectHandleChange}
                      name="unit_id"
                      options={unit}
                    />
                  </div>
                  <div className="col-lg">
                    <label>
                      Price <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="price"
                      value={inputs.price || ""}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label>
                      SKU <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="sku"
                      value={inputs.sku || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>Pack Size</label>
                    <input
                      type="text"
                      className="form-control"
                      name="pack_size"
                      value={inputs.pack_size || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>Stock</label>
                    <input
                      type="text"
                      className="form-control"
                      name="stock"
                      value={inputs.stock || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>
                      Type <i className="fa fa-star required"></i>
                    </label>
                    <select
                      className="form-control"
                      name="type"
                      onChange={handleChange}
                    >
                      <option value="">Select Type</option>
                      <option
                        value="raw_materials"
                        selected={
                          inputs.type === "raw_materials" ? true : false
                        }
                      >
                        Raw Materials
                      </option>
                      <option
                        value="packing_materials"
                        selected={
                          inputs.type === "packing_materials" ? true : false
                        }
                      >
                        Packing Materials
                      </option>
                      <option
                        value="finished_goods"
                        selected={
                          inputs.type === "finished_goods" ? true : false
                        }
                      >
                        Finished Goods
                      </option>
                      <option
                        value="spare_parts"
                        selected={
                          inputs.type === "spare_parts" ? true : false
                        }
                      >
                        Spare Parts
                      </option>
                    </select>
                  </div>
                </div>

                {inputs.type === "finished_goods" && (
                  <div className="row mt-3">
                    <div className="col-lg">
                      <label>Supported Shapes</label>
                      <Select
                        isMulti
                        className="basic-multi-select"
                        classNamePrefix="select"
                        name="supported_shapes"
                        options={shapes}
                        isLoading={shapesLoading}
                        value={selectedShapes}
                        onChange={handleMultiSelectChange}
                        placeholder={
                          shapesLoading ? "Loading shapes..." : "Select supported shapes"
                        }
                        isDisabled={shapesLoading || shapesError}
                        noOptionsMessage={() => shapesError || "No shapes found"}
                      />
                    </div>
                  </div>
                )}
                

                <div className="row mt-3">
                {inputs.type !== "finished_goods" && (
                    <div className="col-lg">
                      <label htmlFor="">
                        Department <i className="fa fa-star required"></i>
                      </label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={"select Department"}
                        onChange={selectHandleChange}
                        name="department_art_id"
                        options={departments}
                      />
                    </div>
                  )}
                  {/* <div className="col-lg">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        name="department_finished_good"
                        className="form-check-input"
                        checked={inputs.department_finished_good || false}
                        onChange={handleChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckChecked"
                      >
                        Mushok 6.4 Show
                      </label>
                    </div>
                  </div> */}
                  <div className="col-lg">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        name="has_handle"
                        className="form-check-input"
                        checked={inputs.has_handle || false}
                        onChange={handleChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckChecked"
                      >
                        Has Handle
                      </label>
                    </div>
                  </div>
                  {inputs.type === "finished_goods" && (
                    <div className="col-lg">
                      <label htmlFor="">
                        Department <i className="fa fa-star required"></i>
                      </label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={selectedDepartmentArt}
                        value={selectedDepartmentArt}
                        onChange={selectHandleChange}
                        name="department_art_id"
                        options={finishedGoodsDepartments}
                        isDisabled
                      />
                    </div>
                  )}
                  <div className="col-lg">
                    <label>Status</label>
                    <select
                      className="form-control"
                      name="status"
                      onChange={handleChange}
                    >
                      <option value="">Select Status</option>
                      <option
                        value="active"
                        selected={inputs.status === "active" ? true : false}
                      >
                        Active
                      </option>
                      <option
                        value="inactive"
                        selected={inputs.status === "inactive" ? true : false}
                      >
                        Inactive
                      </option>
                    </select>
                  </div>
                </div>
                {/* {showAccountsForm && (
                  <>
                    <div className="row mt-5">
                      <div className="col-md-12 mb-3">
                        <h4 className="text-center">Accounts</h4>
                        <hr />
                      </div>

                      <div className="col-lg-6">
                        <label>STD For Accounts:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="std_price_accounts"
                          value={inputs.std_price_accounts || ""}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-6">
                        <label>Vat For Accounts:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="vat_value_accounts"
                          value={inputs.vat_value_accounts || ""}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-12 mt-5">
                        <h4 className="text-center">চালান</h4>
                        <hr />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-lg">
                        <label>একক মূল্য(টাকায়):</label>
                        <input
                          type="text"
                          className="form-control"
                          name="sdv_inv"
                          value={inputs.sdv_inv || ""}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-lg">
                        <label>সম্পুরক শুল্কের হার:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="sd_inv"
                          value={inputs.sd_inv || ""}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-lg">
                        <label>মূল্য সংযোজন করের হার/সুনির্দিষ্ট কর:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="vat_inv"
                          value={inputs.vat_inv || ""}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-lg">
                        <label>
                          সরবরাহের একক: <i className="fa fa-star required"></i>
                        </label>
                        <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={unitSupply[0]}
                      name="unit_supply"
                      options={unitSupply}
                      onChange={selectHandleChange}
                    />

                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          defaultValue={selectedUnitSupplyOption}
                          value={selectedUnitSupplyOption}
                          onChange={selectHandleChange}
                          name="unit_supply"
                          options={unitSupply}
                        />
                      </div>
                      <div className="col-lg">
                        <label>
                          পরিমাণ: <i className="fa fa-star required"></i>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="unit_supply_qty"
                          value={inputs.unit_supply_qty || ""}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-lg">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            name="mushok_6_4_show"
                            className="form-check-input"
                            checked={inputs.mushok_6_4_show || false}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexCheckChecked"
                          >
                            Mushok 6.4 Show
                          </label>
                        </div>
                      </div>
                    </div>
                  </>
                )} */}

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Update
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Edit;
